<template>
  <div
    class="page"
    :style="{
      height: `calc(100vh - ${offsetHeight}px)`,
    }"
  >
    <AgGridVue
      id="myGrid"
      style="width: 100%; height: calc(100% - 70px);"
      class="ag-theme-alpine "
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :default-col-def="defaultColDef"
      :animate-rows="true"
      :enable-filter="true"
      :enable-col-resize="true"
      :enable-sorting="true"
      row-selection="single"
      :get-row-node-id="getRowNodeId"
      :modules="modules"
      :framework-components="frameworkComponents"
      @grid-ready="onGridReady"
      @first-data-rendered="dataRendered"
      @selection-changed="onSelectionChanged"
      @cell-double-clicked="onCellDoubleClicked"
    ></AgGridVue>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

// import { AllCommunityModules } from '@ag-grid-community/all-modules'

import enableDisableEditor from './grid/enableDisabledCellEditor.js'
import enableDisableRenderer from './grid/enableDisabledRenderer.js'

function setPrinterFriendly(api) {
  var eGridDiv = document.querySelector('#myGrid')
  eGridDiv.style.width = ''
  eGridDiv.style.height = ''
  api.setDomLayout('print')
}

function setNormal(api) {
  var eGridDiv = document.querySelector('#myGrid')
  eGridDiv.style.width = '100%'
  eGridDiv.style.height = 'calc(100% - 34px)'
  api.setDomLayout(null)
}

export default {
  name: 'Grid',
  components: {
    AgGridVue,
  },
  props: {
    resizeHeaders: {
      type: Boolean,
      default: false,
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    filter: {
      type: [String],
      default: null,
    },
    filterCol: {
      type: String,
      required: false,
      default: null,
    },
    quickFilter: {
      type: String,
      default: null,
    },
    gridData: {
      type: Array,
      default() {
        return []
      },
    },
    arrayFilter: {
      type: Array,
      default: () => {
        return []
      },
    },
    idKey: {
      type: String,
      default: 'id',
    },
  },
  data: function() {
    return {
      offsetHeight: 0,
      gridOptions: {},
      gridApi: null,
      columnApi: null,
      defaultColDef: null,
      rowData: null,

      frameworkComponents: null,
    }
  },
  watch: {
    filter: {
      handler(val) {
        if (val) {
          this.filterGrid(val, this.filterCol)
        } else {
          this.clearFilters(null, this.filterCol)
        }
      },
    },
    arrayFilter: {
      handler(states) {
        if (states.length === 0) {
          var filterCol = this.gridApi.getFilterInstance(this.filterCol)
          filterCol.setModel()
          this.gridApi.onFilterChanged()
        } else if (states.length === 1) {
          this.filterGrid(states[0], this.filterCol)
        } else if (states.length > 1) {
          this.filterGridArray(states, this.filterCol)
        }
      },
    },
    quickFilter: {
      handler(filterTerm) {
        this.quickFilterFunc(filterTerm)
      },
    },
    gridData: {
      immediate: false,
      handler(data) {
        
        const newGridData = data
        // this.rowData = newGridData
        if (this.gridOptions) {
          this.gridOptions.api.setRowData(newGridData)
        }

        // setTimeout(() => this.autoSizeAll(this.resizeHeaders), 250)
      },
    },
  },

  beforeMount() {
    this.gridOptions = {}
    this.defaultColDef = { sortable: true, filter: true }

    this.frameworkComponents = {
      edRenderer: enableDisableRenderer,
      edEditor: enableDisableEditor,
    }

    if (this.$mq.above(992)) {
      this.offsetHeight = 75
    } else {
      this.offsetHeight = 175
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  methods: {
    dataRendered() {
      this.autoSizeAll(this.resizeHeaders)
    },
    onBtPrint() {
      var gridApi = this.gridApi
      setPrinterFriendly(gridApi)
      setTimeout(function() {
        print()
        setNormal(gridApi)
      }, 2000)
    },
    onBtnExport(params) {
      this.gridApi.exportDataAsCsv(params)
    },
    onGridReady(params) {},
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows()

      this.$emit('onSelectionChanged', selectedRows)
    },
    onCellDoubleClicked() {
      var selectedRows = this.gridApi.getSelectedRows()
      this.$emit('onCellDoubleClicked', selectedRows)
    },
    filterGrid(filterTerm, col) {
      var hardcodedFilter = {}
      hardcodedFilter[col] = {
        type: 'contains',
        filter: filterTerm,
      }
      this.gridApi.setFilterModel(hardcodedFilter)
      this.gridApi.onFilterChanged()
    },
    filterGridArray(array, col) {
      var filterCol = this.gridApi.getFilterInstance('FlightStatus')
      var conditions = {}
      array.forEach((state, index) => {
        conditions[`condition${index + 1}`] = {
          type: 'startsWith',
          filter: state,
        }
      })
      conditions.operator = 'OR'

      filterCol.setModel(conditions)
      this.gridApi.onFilterChanged()
    },
    clearFilters() {
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
    },
    autoSizeAll(skipHeader) {
      var allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.colId)
      })
      this.$nextTick().then(() =>
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader)
      )
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader)
    },
    getRowNodeId(data) {
      const id = data[this.idKey]
      console.log('id', id)
      return id
    },
    quickFilterFunc(filterTerm) {
      this.gridApi.setQuickFilter(filterTerm)
    },
  },
}
</script>

<style>
.layout-nav-side .content-container > .chat-module,
.layout-sidebar .content-container > .chat-module {
  overflow: hidden;
  padding: 0;
}
.ag-theme-balham .ag-root {
  border: 0px solid #bdc3c7;
}

.mood {
  border-radius: 15px;
  border: 1px solid grey;
  background: #e6e6e6;
  padding: 15px;
  text-align: center;
  display: inline-block;
  outline: none;
}

.default {
  border: 1px solid transparent !important;
  padding: 4px;
}

.selected {
  border: 1px solid lightgreen !important;
  padding: 4px;
}



/* 

.toggleWrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  -webkit-transform: translate3d(-50%, -50%, 0);
          transform: translate3d(-50%, -50%, 0);
}
.toggleWrapper input {
  position: absolute;
  left: -99em;
}

.toggle {
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: 220px;
  height: 50px;
  background: #D21626;
  border-radius: 5px;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.toggle:before, .toggle:after {
  position: absolute;
  line-height: 50px;
  font-size: 14px;
  z-index: 2;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.toggle:before {
  content: "DISBALED";
  left: 20px;
  color: #D21626;
}
.toggle:after {
  content: "ENABLED";
  right: 20px;
  color: #fff;
}

.toggle__handler {
  display: inline-block;
  position: relative;
  z-index: 1;
  background: #fff;
  width: 100px;
  height: 44px;
  border-radius: 3px;
  top: 3px;
  left: 3px;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -webkit-transform: translateX(0px);
          transform: translateX(0px);
}

input:checked + .toggle {
  background: #66B317;
}
input:checked + .toggle:before {
  color: #fff;
}
input:checked + .toggle:after {
  color: #66B317;
}
input:checked + .toggle .toggle__handler {
  width: 95px;
  -webkit-transform: translateX(119px);
          transform: translateX(119px);
  border-color: #fff;
} */

</style>
